import React from "react";
import type { FC, PropsWithChildren } from "react";
import PatientStyle from "../../styles/Patient.module.css";
import EnrollPatientStyle from "../../styles/EnrollPatient.module.css";
import InputField from "../../components/Modal/InputField";
import SelectInputBox from "../../components/Modal/SelectInputBox";
import { InputsSection } from "../../components/Modal";
import { inputPhoneMasking } from "../../utils/validators";
import { IAssociatedClinic, IState } from "../../hooks/patients/index.type";
import { useFetchBillingProvider } from "../../hooks/patients";
import { IaddPatientModalStates, IntakeFormQuestion } from "./AddPatientModal";
import CheckboxInput from "../../components/Modal/CheckBoxInput";

export type AddPatientModalState = PropsWithChildren<{
  status: boolean;
}>;

type AddEditModalProps = PropsWithChildren<{
  addEditModalStates: IaddPatientModalStates;
  setAddEditModalStates: React.Dispatch<
    React.SetStateAction<IaddPatientModalStates>
  >;
  isUpdateMode?: boolean;
}>;

const InsuranceInfoSection: FC<AddEditModalProps> = (props) => {
  return (
    <div className={EnrollPatientStyle.insuranceContainer}>
      {/* Primary Insurance Section */}
      <InputsSection customClass={EnrollPatientStyle.insuranceGridSection}>
        <InputField
          label="Primary Insurance Provider (Optional)"
          value={props.addEditModalStates.primaryInsurance.provider.value}
          onChange={(event) => {
            props.setAddEditModalStates((prevVal) => ({
              ...prevVal,
              primaryInsurance: {
                ...prevVal.primaryInsurance,
                provider: { value: event.target.value, error: "" },
              },
            }));
          }}
          errorMessage={
            props.addEditModalStates.primaryInsurance.provider.error
          }
          style={{ maxWidth: "100%" }}
          customClass={EnrollPatientStyle.insuranceSectionInput}
          containerClass={EnrollPatientStyle.enrollInputContainer}
          placeholder="Enter Provider Name"
          labelClass={EnrollPatientStyle.enrollInputLabel}
        />

        <InputField
          label=""
          value={props.addEditModalStates.primaryInsurance.policyNumber.value}
          onChange={(event) => {
            props.setAddEditModalStates((prevVal) => ({
              ...prevVal,
              primaryInsurance: {
                ...prevVal.primaryInsurance,
                policyNumber: { value: event.target.value, error: "" },
              },
            }));
          }}
          errorMessage={
            props.addEditModalStates.primaryInsurance.policyNumber.error
          }
          style={{ maxWidth: "100%" }}
          customClass={EnrollPatientStyle.insuranceSectionInput}
          containerClass={EnrollPatientStyle.enrollInputContainer}
          placeholder="Enter Policy Number"
          labelClass={EnrollPatientStyle.enrollInputLabel}
        />

        <InputField
          label=""
          value={props.addEditModalStates.primaryInsurance.groupNumber.value}
          onChange={(event) => {
            props.setAddEditModalStates((prevVal) => ({
              ...prevVal,
              primaryInsurance: {
                ...prevVal.primaryInsurance,
                groupNumber: { value: event.target.value, error: "" },
              },
            }));
          }}
          errorMessage={
            props.addEditModalStates.primaryInsurance.groupNumber.error
          }
          style={{ maxWidth: "100%" }}
          customClass={EnrollPatientStyle.insuranceSectionInput}
          containerClass={EnrollPatientStyle.enrollInputContainer}
          placeholder="Enter Group Number"
          labelClass={EnrollPatientStyle.enrollInputLabel}
        />
      </InputsSection>

      {/* Secondary Insurance Section */}
      <InputsSection customClass={EnrollPatientStyle.insuranceGridSection}>
        <InputField
          label="Secondary Insurance Provider (Optional)"
          value={props.addEditModalStates.secondaryInsurance.provider.value}
          onChange={(event) => {
            props.setAddEditModalStates((prevVal) => ({
              ...prevVal,
              secondaryInsurance: {
                ...prevVal.secondaryInsurance,
                provider: { value: event.target.value, error: "" },
              },
            }));
          }}
          errorMessage={
            props.addEditModalStates.secondaryInsurance.provider.error
          }
          style={{ maxWidth: "100%" }}
          customClass={EnrollPatientStyle.insuranceSectionInput}
          containerClass={EnrollPatientStyle.enrollInputContainer}
          placeholder="Enter Provider Name"
          labelClass={EnrollPatientStyle.enrollInputLabel}
        />

        <InputField
          label=""
          value={props.addEditModalStates.secondaryInsurance.policyNumber.value}
          onChange={(event) => {
            props.setAddEditModalStates((prevVal) => ({
              ...prevVal,
              secondaryInsurance: {
                ...prevVal.secondaryInsurance,
                policyNumber: { value: event.target.value, error: "" },
              },
            }));
          }}
          errorMessage={
            props.addEditModalStates.secondaryInsurance.policyNumber.error
          }
          style={{ maxWidth: "100%" }}
          customClass={EnrollPatientStyle.insuranceSectionInput}
          containerClass={EnrollPatientStyle.enrollInputContainer}
          placeholder="Enter Policy Number"
          labelClass={EnrollPatientStyle.enrollInputLabel}
        />

        <InputField
          label=""
          value={props.addEditModalStates.secondaryInsurance.groupNumber.value}
          onChange={(event) => {
            props.setAddEditModalStates((prevVal) => ({
              ...prevVal,
              secondaryInsurance: {
                ...prevVal.secondaryInsurance,
                groupNumber: { value: event.target.value, error: "" },
              },
            }));
          }}
          errorMessage={
            props.addEditModalStates.secondaryInsurance.groupNumber.error
          }
          style={{ maxWidth: "100%" }}
          customClass={EnrollPatientStyle.insuranceSectionInput}
          containerClass={EnrollPatientStyle.enrollInputContainer}
          placeholder="Enter Group Number"
          labelClass={EnrollPatientStyle.enrollInputLabel}
        />
      </InputsSection>
      <CheckboxInput
        label="Self-Pay"
        checked={props.addEditModalStates.rtmSelfPay.value === "yes"}
        onChange={(e) => {
          props.setAddEditModalStates((prev) => ({
            ...prev,
            rtmSelfPay: {
              value: e.target.checked ? "yes" : "no",
              error: "",
            },
          }));
        }}
      />
    </div>
  );
};

export default InsuranceInfoSection;
